import { type QueryOptions } from '@tanstack/query-core'

import { type ShipmentOrderInputHistoryListEntity } from '@/libs/api'

import { fetchShipmentOrderHistories } from '../api/fetch-shipment-order-histories'
import { shipmentOrderHistoriesQueryKeys } from '../query-keys'

/**
 * Select用の配送依頼履歴一覧のQueryOptionsを返す
 */
export const getShipmentOrderHistoriesSelectQueryOptions = (
  tenantKey: string,
  dcId: number,
  options?: {
    originSiteId?: number
    destSiteId?: number
    shipmentCategoryId?: number
    customerId?: number
  }
): Required<
  Pick<
    QueryOptions<ShipmentOrderInputHistoryListEntity[]>,
    'queryKey' | 'queryFn'
  >
> => {
  return {
    queryKey: [
      ...shipmentOrderHistoriesQueryKeys.select(tenantKey),
      options?.originSiteId,
      options?.destSiteId,
      options?.shipmentCategoryId,
      options?.customerId
    ],
    queryFn: async ({ signal }) => {
      const { data } = await fetchShipmentOrderHistories(
        {
          tenantKey,
          dcId,
          originSiteId: options?.originSiteId,
          destSiteId: options?.destSiteId,
          customerId: options?.customerId,
          shipmentCategoryId: options?.shipmentCategoryId
        },
        signal
      )
      return data
    }
  }
}
